var _path, _rect, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _path9, _polygon2, _path10, _circle4, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 706.53539,
    height: 428.76001,
    viewBox: "0 0 706.53539 428.76001",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M862.452,235.62h-607a8.72766,8.72766,0,0,0-8.71972,8.72V655.66a8.72766,8.72766,0,0,0,8.71972,8.72h607a8.71244,8.71244,0,0,0,6.63037-3.06,2.0459,2.0459,0,0,0,.18995-.24,8.1667,8.1667,0,0,0,1.25-2.11005,8.50722,8.50722,0,0,0,.65966-3.31V244.34A8.72953,8.72953,0,0,0,862.452,235.62Zm6.24024,420.04a6.17527,6.17527,0,0,1-1.03028,3.42,6.44588,6.44588,0,0,1-2.35986,2.12,6.1843,6.1843,0,0,1-2.8501.69h-607a6.23757,6.23757,0,0,1-6.23-6.23V244.34a6.23757,6.23757,0,0,1,6.23-6.23h607a6.23944,6.23944,0,0,1,6.24024,6.23Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.24265,
    y: 34.94921,
    width: 621.95676,
    height: 2.49281,
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.43155,
    cy: 18.6961,
    r: 7.47844,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.93206,
    cy: 18.6961,
    r: 7.47844,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.43257,
    cy: 18.6961,
    r: 7.47844,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.78393,427.36614h-22a4.505,4.505,0,0,1-4.5-4.5v-22a4.505,4.505,0,0,1,4.5-4.5h22a4.505,4.505,0,0,1,4.5,4.5v22A4.505,4.505,0,0,1,321.78393,427.36614Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#c8102e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M321.78393,484.36614h-22a4.505,4.505,0,0,1-4.5-4.5v-22a4.505,4.505,0,0,1,4.5-4.5h22a4.505,4.505,0,0,1,4.5,4.5v22A4.505,4.505,0,0,1,321.78393,484.36614Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M321.78393,541.36614h-22a4.505,4.505,0,0,1-4.5-4.5v-22a4.505,4.505,0,0,1,4.5-4.5h22a4.505,4.505,0,0,1,4.5,4.5v22A4.505,4.505,0,0,1,321.78393,541.36614Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M465.78393,416.36614h-106a4.5,4.5,0,1,1,0-9h106a4.5,4.5,0,0,1,0,9Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M465.78393,473.36614h-106a4.5,4.5,0,1,1,0-9h106a4.5,4.5,0,0,1,0,9Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M465.78393,530.36614h-106a4.5,4.5,0,1,1,0-9h106a4.5,4.5,0,0,1,0,9Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M829.55378,407.43591a10.09326,10.09326,0,0,1,1.41075.78731l44.8523-19.1432,1.60093-11.81526,17.92157-.10956-1.05874,27.0982-59.19986,15.65584a10.60791,10.60791,0,0,1-.44749,1.20835,10.2346,10.2346,0,1,1-5.07946-13.68168Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "655.125 417.376 642.865 417.375 637.033 370.087 655.127 370.088 655.125 417.376",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M634.10773,413.87226H657.7516a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H619.22087a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,634.10773,413.87226Z",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "702.805 413.911 690.604 415.113 680.163 368.625 698.17 366.851 702.805 413.911",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M928.987,647.64055h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H914.10012a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,928.987,647.64055Z",
    transform: "translate(-306.45017 -140.97479) rotate(-5.62529)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.53741,
    cy: 66.92823,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M886.85757,643.43243a4.47086,4.47086,0,0,1-4.415-3.69726c-6.34571-35.22559-27.0879-150.40528-27.584-153.5957a1.427,1.427,0,0,1-.01562-.22168v-8.5879a1.489,1.489,0,0,1,.27929-.87207l2.74024-3.83789a1.47848,1.47848,0,0,1,1.14355-.625c15.62207-.73242,66.78418-2.8789,69.25586.209h0c2.48242,3.10351,1.60547,12.50683,1.4043,14.36035l.00976.19336,22.98536,146.99512a4.51239,4.51239,0,0,1-3.71485,5.13476L934.59,641.25275a4.52127,4.52127,0,0,1-5.02539-3.09278c-4.44043-14.18847-19.32911-61.918-24.48926-80.38672a.49922.49922,0,0,0-.98047.13868c.25781,17.60546.88086,62.52343,1.0957,78.03711l.02344,1.67089a4.51811,4.51811,0,0,1-4.09277,4.53614l-13.84375,1.25781C887.13687,643.42657,886.99625,643.43243,886.85757,643.43243Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "e15ec395-f7cd-4347-89a2-a03d95a452a7-224",
    "data-name": "Path 99",
    d: "M889.68211,336.76678c-4.28634,2.548-6.85116,7.23043-8.32276,11.9951a113.681,113.681,0,0,0-4.88444,27.15943l-1.55553,27.60021-19.25508,73.1699c16.6887,14.1207,26.31542,10.91153,48.78049-.63879S929.477,479.9038,929.477,479.9038l4.49235-62.25839,6.41838-68.03232a30.16418,30.16418,0,0,0-4.86143-4.67415,49.65848,49.65848,0,0,0-42.44229-8.99538Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#b3b3b3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M883.42783,422.21345a10.52612,10.52612,0,0,1,1.50061.70389l44.34832-22.1972.736-12.02551,18.2938-1.26127.9804,27.4126-59.26586,19.59937a10.4958,10.4958,0,1,1-6.59329-12.23188Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "bf6aefed-5d84-44a4-8c4e-9d1f3daa58d8-225",
    "data-name": "Path 101",
    d: "M940.06674,349.92449c10.91151,3.85117,12.83354,45.57369,12.83354,45.57369-12.83671-7.06036-28.24139,4.49318-28.24139,4.49318s-3.20917-10.91153-7.06034-25.03223a24.52987,24.52987,0,0,1,5.13436-23.10625S929.15523,346.07093,940.06674,349.92449Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#b3b3b3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "f516f9fe-dc87-4aac-a802-2e179304beb7-226",
    "data-name": "Path 102",
    d: "M927.29244,309.0435c-3.06-2.44837-7.23517,2.00173-7.23517,2.00173l-2.4484-22.03349s-15.301,1.83291-25.0935-.61161-11.32255,8.87513-11.32255,8.87513a78.58075,78.58075,0,0,1-.30583-13.77092c.61159-5.50838,8.56839-11.01675,22.6451-14.68932S924.953,281.056,924.953,281.056C934.74664,285.95175,930.35243,311.49189,927.29244,309.0435Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M834.53589,470.86614c.1582-2.64728.248-5.31293.248-8a132.00012,132.00012,0,0,0-132-132v140Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#c8102e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M692.78393,482.86614v-140a132,132,0,1,0,131.752,140Z",
    transform: "translate(-246.73231 -235.62)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt2);
export default __webpack_public_path__ + "static/media/ST2.7d697349448a98a58a91080c28b38992.svg";
export { ForwardRef as ReactComponent };